import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelectableOrderComponent } from 'src/app/feature';
import { ShoppingCartHandlerService } from '../../services';

@Component({
  selector: 'order-review-mode',
  templateUrl: './order-review-mode.component.html',
  styleUrls: ['./order-review-mode.component.sass'],
})
export class OrderReviewModeComponent
  extends SelectableOrderComponent
  implements OnInit
{
  constructor(
    handler: ShoppingCartHandlerService,
    dialog: MatDialog,
    router: Router
  ) {
    super(handler, dialog, router);
  }

  override ngOnInit(): void {}
}
